import React from 'react'
import PropTypes from 'prop-types'

// Components
import Grid from '../../Grid'
import MapNavItem from '../MapNavItem'

// Styles
import { MapNavigation } from './index.style'

// Images
import Route1BG from '../assets/1.jpg'
import Route2BG from '../assets/2.jpg'
import Route3BG from '../assets/3.jpg'
import Route4BG from '../assets/4.jpg'

const MapNav = props => {
  const MapNavData = [
    {
      label: props.section1Dates,
      heading: props.section1Title,
      text: props.section1Copy,
      color: `#49A5A7`,
      image: Route1BG,
    },
    {
      label: props.section2Dates,
      heading: props.section2Title,
      text: props.section2Copy,
      color: `#C92C72`,
      image: Route2BG,
    },
    {
      label: props.section3Dates,
      heading: props.section3Title,
      text: props.section3Copy,
      color: `#E16A2B`,
      image: Route3BG,
    },
    {
      label: props.section4Dates,
      heading: props.section4Title,
      text: props.section4Copy,
      color: `#70A531`,
      image: Route4BG,
    },
  ]

  return (
    <MapNavigation id={'map'}>
      <Grid gutters={false}>
        {MapNavData &&
          React.Children.toArray(
            MapNavData.map((item, itemIndex) => {
              return (
                <MapNavItem
                  {...item}
                  id={`${props.id}-${itemIndex}`}
                  active={itemIndex === props.mapIndex}
                  setActive={e => {
                    e && e.preventDefault()
                    props.scrollToMap()
                    props.setMapIndex(itemIndex)
                  }}
                  delay={itemIndex * 0.1}
                />
              )
            })
          )}
      </Grid>
    </MapNavigation>
  )
}

MapNav.propTypes = {
  mapIndex: PropTypes.number,
  setMapIndex: PropTypes.func,
  scrollToMap: PropTypes.func,
  section1Dates: PropTypes.string,
  section1Title: PropTypes.object,
  section1Copy: PropTypes.string,
  section2Dates: PropTypes.string,
  section2Title: PropTypes.object,
  section2Copy: PropTypes.string,
  section3Dates: PropTypes.string,
  section3Title: PropTypes.object,
  section3Copy: PropTypes.string,
  section4Dates: PropTypes.string,
  section4Title: PropTypes.object,
  section4Copy: PropTypes.string,
}

export default MapNav
